module.exports = __webpack_public_path__ + "img/icon-core2-2.1bd9f855.png";